export default __webpack_public_path__ + "static/media/sc2.6039f033.mp4";